"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatProgress = exports.PROGRESS_BAR_THRESHOLD_WIDTH = exports.PROGRESS_BAR_THRESHOLD_HEIGHT = exports.PROGRESS_BAR_MIN_WIDTH = exports.PROGRESS_BAR_HEIGHT = exports.PROGRESS_BAR_BORDER_WIDTH = exports.PROGRESS_BAR_BORDER_RADIUS = void 0;
var PROGRESS_BAR_HEIGHT = 8;
exports.PROGRESS_BAR_HEIGHT = PROGRESS_BAR_HEIGHT;
var PROGRESS_BAR_BORDER_WIDTH = 1;
exports.PROGRESS_BAR_BORDER_WIDTH = PROGRESS_BAR_BORDER_WIDTH;
var PROGRESS_BAR_MIN_WIDTH = 112;
exports.PROGRESS_BAR_MIN_WIDTH = PROGRESS_BAR_MIN_WIDTH;
var PROGRESS_BAR_BORDER_RADIUS = 1000;
exports.PROGRESS_BAR_BORDER_RADIUS = PROGRESS_BAR_BORDER_RADIUS;
var PROGRESS_BAR_THRESHOLD_HEIGHT = 12;
exports.PROGRESS_BAR_THRESHOLD_HEIGHT = PROGRESS_BAR_THRESHOLD_HEIGHT;
var PROGRESS_BAR_THRESHOLD_WIDTH = 2;
exports.PROGRESS_BAR_THRESHOLD_WIDTH = PROGRESS_BAR_THRESHOLD_WIDTH;

var formatProgress = function formatProgress(amount) {
  return parseFloat((amount * 100).toPrecision(3));
};

exports.formatProgress = formatProgress;